import PropTypes from 'prop-types';
import { Box, Typography, Button } from '@mui/material';
import { ShoppingCartRounded } from '@mui/icons-material';
import WhatsAppBubble from './WhatsAppBubble';

function buildPreview(selectedModel, messageNotes) {
  const trimmed = messageNotes?.trim();
  if (!selectedModel) return 'Pré-visualização indisponível.';
  return trimmed
    ? (selectedModel.previewCreatedWithNotes || '').replace('{{ORIENTACOES}}', trimmed)
    : (selectedModel.previewCreated || '');
}

/**
 * WhatsAppPreviewAside — coluna de apoio (estado ativado): saldo em destaque,
 * pré-visualização ao vivo da mensagem e atalho para os pacotes. Sticky em lg+.
 */
export default function WhatsAppPreviewAside({
  selectedModel,
  messageNotes,
  waBalance,
  waLow,
  onScrollToCatalog,
}) {
  const balance = waBalance ?? 0;
  const balanceColor = balance === 0 ? 'error.main' : waLow ? 'warning.main' : 'success.main';

  return (
    <Box
      sx={{
        position: { lg: 'sticky' },
        top: { lg: 16 },
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      {/* Saldo em destaque */}
      <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, p: 2 }}>
        <Typography variant="caption" color="text.secondary">Saldo de mensagens</Typography>
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.75, mt: 0.25 }}>
          <Typography variant="h4" fontWeight={700} sx={{ color: balanceColor, lineHeight: 1 }}>
            {balance}
          </Typography>
          <Typography variant="body2" color="text.secondary">créditos</Typography>
        </Box>
        <Button
          variant="outlined"
          color="success"
          size="small"
          fullWidth
          startIcon={<ShoppingCartRounded />}
          onClick={onScrollToCatalog}
          sx={{ mt: 1.5 }}
        >
          Comprar mais
        </Button>
      </Box>

      {/* Pré-visualização ao vivo */}
      <Box>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
          Pré-visualização — ao vivo
        </Typography>
        <WhatsAppBubble text={buildPreview(selectedModel, messageNotes)} />
      </Box>
    </Box>
  );
}

WhatsAppPreviewAside.propTypes = {
  selectedModel: PropTypes.object,
  messageNotes: PropTypes.string,
  waBalance: PropTypes.number,
  waLow: PropTypes.bool,
  onScrollToCatalog: PropTypes.func.isRequired,
};
